<template>
    <div>
        <p class="lead text-left my-4">Admin Area</p>        

    <!--BOSS SECTION-->
        <div v-if="getCurrentUser.userrole === 'boss'" class="text-left">
            <small>Босс, меню в помощь!</small>
            <app-select-menu></app-select-menu>            
        </div>

    <!--ADMIN SECTION-->
        <div v-if="getCurrentUser.userrole === 'user'">
            <p class="lead text-left my-4">Manager area</p>
            <small>Привет {{getCurrentUser.username}}</small>
        </div>

    <!--USER SECTION
           ... content will appear here ...
        -->

    <!--CONFIRMATION MESSAGES-->
        <app-confirmation v-if="showingMessageModal" 
                          @showDialogue="closeDialogue" 
                          :successMessage="successMessage" 
                          :errorMessage="errorMessage" />        
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'
    import selectMenu from '@/components/Helpers/SelectMenu'
    import conDialog from '@/components/Helpers/ConfirmationDialogue'
    import Users from '@/components/Users/Users'

    export default {
        components: {
                appSelectMenu: selectMenu,
                appConfirmation : conDialog,
                appAllUsers: Users
            },
        data(){
                return {
                    apiURL: process.env.APP_API,
                    successMessage: '',
                    errorMessage: '',
                    showingMessageModal: null,
                    id: null,
                    security: null
                }
            },
        beforeRouteEnter(to, from, next){
                next(vm => {
                     vm.authCheck()
                })
            },
        computed: {
                ...mapGetters([
                        'getCurrentUser', 'getUserStatus'
                    ])
                },
        methods: {
            ...mapActions([
                    'updateUser'
                ]),
            authCheck(){
                if(localStorage.id && localStorage.security) {

                    var formData = new FormData()
                        formData.append('localId', localStorage.id)                
                        formData.append('localSecurity', localStorage.security)    

                   axios.post(this.apiURL + '?action=checkAuth', formData)
                        .then((res) => {
                            if(res.data.error){
                                console.log('Аутентификация не прошла!')                                
                                this.$router.push('/')
                            } else {
                                console.log('Проверка аутентификации для ' + res.data.username + ' прошла успешно!')
                                this.updateUser(res.data.user)
                            }
                        })
                    } else {
                        this.$router.push({name: 'Login'})                  
                    }                  
                },
            closeDialogue(status){
                this.showingMessageModal = status
                },         
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Admin.vue